module.exports = __webpack_public_path__ + "img/anchor_cancer_bg.f48f2f92.png";